/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, arrayOf, none, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { JobSharedDocListItemDto, JobSharedDocNewSetDto } from './job-shared-docs.dto';
import { JobSharedDocListItemMapper, JobSharedDocNewSetMapper } from './job-shared-docs.mapper';

@Injectable()
export class JobSharedDocRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  findAllByJobId(jobId: ID): Observable<JobSharedDocListItemDto[]> {
    return this.httpGet(`${this.bp}/jobs/${jobId}/shared-docs`, arrayOf(JobSharedDocListItemMapper));
  }

  share(jobId: ID, sets: JobSharedDocNewSetDto[]): Observable<void> {
    return this.httpPost(`${this.bp}/jobs/${jobId}/shared-docs`, sets, arrayOf(JobSharedDocNewSetMapper), none());
  }

  unshare(jobId: ID, sharedDocId: ID): Observable<void> {
    return this.httpDelete(`${this.bp}/jobs/${jobId}/shared-docs/${sharedDocId}`, void 0, none());
  }
}
